export default "__VITE_ASSET__f04f3bf6__"